import { useCallback } from 'react';
import type { AnalyticsEvent } from '@pantry/analytics';

/**
 * Platform-specific analytics backend. Must be memoized (useMemo) by callers —
 * useAnalyticsCore depends on adapter identity for useCallback deps.
 */
export interface AnalyticsAdapter {
  capture: (event: string, properties?: Record<string, unknown>) => void;
  identify?: (userId: string, properties?: Record<string, unknown>) => void;
  reset?: () => void;
}

export function useAnalyticsCore(adapter: AnalyticsAdapter) {
  const track = useCallback(
    (event: AnalyticsEvent, properties?: Record<string, unknown>) => {
      adapter.capture(event, properties);
    },
    [adapter]
  );
  const identify = useCallback(
    (userId: string, properties?: Record<string, unknown>) => {
      adapter.identify?.(userId, properties);
    },
    [adapter]
  );
  const reset = useCallback(() => {
    adapter.reset?.();
  }, [adapter]);
  return { track, identify, reset };
}
